import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form, InputGroup, Button, FormControl } from "react-bootstrap";
import "./add-equipment.scss";
import ImageCropper from "../ImageCropper";
import * as yup from "yup";
import { saveEquipmentBrand } from "../../../api";
import config from "../../../config";

const STRATUS_URL = config.paymentcloud.STRATUS_URL;

const schema = yup.object({
    brand_name: yup.string().trim().required("* Brand name is required"),
});

export default function AddBrand({ open, close, isEdit, activeBrand }) {
    const [show_spinner, setShowSpinner] = useState(false);
    const [is_submitted, setIsSubmit] = useState(false);
    const [imageCropDialogOpen, setImageCropDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [formData, setFormData] = useState({
        brand_name: activeBrand ? activeBrand.name : "",
        brand_image: null,
        description: activeBrand ? activeBrand.description : "",
    });
    const [errors, setError] = useState([]);
    const [uploadedImage, setUploadedImage] = useState([]);

    const [image_to_show, setImageShow] = useState(null);

    const updateChange = (e) => {
        e.preventDefault();
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleImageCrop = (e) => {
        setImageCropDialogOpen(true);
        setUploadedImage(URL.createObjectURL(e.target.files[0]));
    };

    const submit = () => {
        const form_data = new FormData();
        if (formData.brand_image) {
            form_data.append("brand_image", formData.brand_image);
        }
        form_data.append("brand_name", formData.brand_name);
        form_data.append("description", formData.description);
        if (activeBrand !== null) {
            form_data.append("id", activeBrand.id);
        }

        saveEquipmentBrand(form_data)
            .then((res) => {
                if (res.status) {
                    close();
                }
            })
            .catch((err) => {});
    };

    useEffect(() => {
        setFormData({
            brand_name: activeBrand ? activeBrand.name : "",
            description: activeBrand ? activeBrand.description : "",
        });
    }, [activeBrand]);

    return (
        <ReactModal
            isOpen={open}
            className="add-template-modal add-brand-modal"
        >
            <div className="modal-header">
                <h4 className="text-left">
                    {isEdit ? "Edit Equipment Brand" : "Add Equipment Brand"}
                </h4>
            </div>
            <div onClick={() => close()} className="modal-cancel">
                <img src="/images/cancel.svg" />
            </div>
            <div className="modal-body">
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(e) => submit()}
                    initialValues={formData}
                    initialErrors={errors}
                    validateOnBlur={false}
                    validateOnChange={is_submitted}
                    validate={(values) => {
                        setIsSubmit(true);
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                    }) => (
                        <Form
                            id="add-template-form"
                            onSubmit={handleSubmit}
                            onChange={(e) => updateChange(e)}
                            autoComplete="off"
                        >
                            <Form.Row>
                                <Form.Group as={Col} xs={12} className="px-3">
                                    <Form.Control
                                        placeholder="Brand Name"
                                        type="text"
                                        name="brand_name"
                                        value={
                                            values.brand_name
                                                ? values.brand_name
                                                : ""
                                        }
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.brand_name &&
                                            !!errors.brand_name
                                        }
                                        isValid={
                                            is_submitted && !errors.brand_name
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">
                                        Brand Name
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.brand_name}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <div className="row">
                                    <div className="col-md-9 col-sm-9">
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <Form.Control
                                                placeholder="Equipment Image"
                                                type="file"
                                                name="brand_image"
                                                value={undefined}
                                                onChange={(e) => {
                                                    handleImageCrop(e);
                                                }}
                                                isInvalid={
                                                    touched.brand_image &&
                                                    !!errors.brand_image
                                                }
                                                isValid={
                                                    is_submitted &&
                                                    !errors.brand_image
                                                }
                                                className="preapp-form-input w-100"
                                            />
                                            <label className="modal-lab">
                                                Brand Image
                                            </label>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {" "}
                                                {errors.brand_image}{" "}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        {activeBrand !== null &&
                                            image_to_show == null && (
                                                <img
                                                    src={`${STRATUS_URL}get-image-by-path?path=${activeBrand.image}`}
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        border: "1px solid #cecece",
                                                        borderRadius: "50%",
                                                        marginTop: "-25%",
                                                    }}
                                                />
                                            )}
                                        {image_to_show !== null && (
                                            <img
                                                src={image_to_show}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    border: "1px solid #cecece",
                                                    borderRadius: "50%",
                                                    marginTop: "-25%",
                                                }}
                                            />
                                        )}
                                    </div>
                                    <ImageCropper
                                        open={imageCropDialogOpen}
                                        image={uploadedImage}
                                        onComplete={(imagePromise) => {
                                            imagePromise.then((image) => {
                                                fetch(image)
                                                    .then((response) =>
                                                        response.blob(),
                                                    ) // Convert the response to a Blob
                                                    .then((blob) => {
                                                        setFormData({
                                                            ...formData,
                                                            brand_image: blob,
                                                        });
                                                        setImageShow(image);
                                                        setImageCropDialogOpen(
                                                            false,
                                                        );
                                                    });
                                            });
                                        }}
                                        containerStyle={{
                                            position: "relative",
                                            width: "100%",
                                            height: 300,
                                            background: "#333",
                                        }}
                                    />
                                </div>

                                <Form.Group as={Col} xs={12} className="px-3">
                                    <label className="modal-lab">
                                        Description
                                    </label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={
                                            values.description
                                                ? values.description
                                                : ""
                                        }
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.description &&
                                            !!errors.description
                                        }
                                        isValid={
                                            is_submitted && !errors.description
                                        }
                                        rows="5"
                                    ></textarea>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.description}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    )}
                </Formik>
            </div>
            {show_spinner ? (
                <div className="spinner">
                    <Loader />
                </div>
            ) : (
                ""
            )}
            <p className="error-message text-center">{errorMessage}</p>
            <div className="modal-footer">
                <div className="button-twoc">
                    <button
                        form="add-template-form"
                        type="submit"
                        disabled={show_spinner}
                        className="btn confirm-button"
                    >
                        {" "}
                        {isEdit ? "Update" : "Add"}{" "}
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={() => close()}
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </div>
        </ReactModal>
    );
}
